import React, { useContext, useState } from "react"
import { useFormContext } from "react-hook-form"

import Button from "src/components/Button"
import ContactBoatPicker from "src/components/ContactBoatPicker"
import PickerSubmitError from "src/components/ContactBoatPicker/PickerSubmitError"
import {
  emptyContact,
  emptyContactBoat,
} from "src/components/ContactBoatPicker/emptyShapes"
import parseResolveError from "src/components/ContactBoatPicker/parseResolveError"
import useContactBoatPicker, {
  PANEL_ARCHIVED,
  PANEL_NONE,
} from "src/components/ContactBoatPicker/useContactBoatPicker"
import Heading from "src/components/Heading"

import { WizardContext } from "../WizardContextProvider"
import { STEPS } from "../constants"
import { PriceEstimate, StepContent, StepWrapper } from "./shared"

const ContactStep = () => {
  const { goToStep } = useContext(WizardContext)
  const methods = useFormContext()
  const [contactId, contactBoatId, contactName] = methods.watch([
    "contact_id",
    "contact_boat_id",
    "contact.name",
  ])

  const picker = useContactBoatPicker({
    emptyContact,
    emptyContactBoat,
    initialContactName: contactName,
  })
  const [submitError, setSubmitError] = useState(null)

  const handleContinueClick = async () => {
    setSubmitError(null)
    try {
      await picker.resolveSelection(methods.getValues())
      goToStep(STEPS.summary)
    } catch (error) {
      const parsed = parseResolveError(error)
      if (parsed) setSubmitError(parsed)
    }
  }

  const continueDisabled =
    picker.panel === PANEL_ARCHIVED ||
    (picker.panel === PANEL_NONE && (!contactId || !contactBoatId))

  return (
    <StepWrapper testId="trw-contact-step">
      <StepContent>
        <Heading.PageTitle>Contact & Boat</Heading.PageTitle>
        <div className="mt-5">
          <ContactBoatPicker handle={picker} enableImport />
          <PickerSubmitError submitError={submitError} />
        </div>
      </StepContent>
      <PriceEstimate>
        <Button
          variant="primary"
          onClick={handleContinueClick}
          isLoading={picker.isWorking}
          disabled={continueDisabled}
        >
          Continue
        </Button>
      </PriceEstimate>
    </StepWrapper>
  )
}

export default ContactStep
